<div class="w-100 landing">
  <div class="container-landing">
    <img
      style="width: 100%"
      [src]="
        isMobile
          ? 'assets/images/landing/background-mobile.svg'
          : 'assets/images/landing/background.svg'
      "
    />
    <div class="centered">
      <img class="logo" src="assets/images/landing/hero-logo.svg" />
      <div class="intro">
        {{ "socpa-intro" | translate }}
      </div>
    </div>
  </div>
  <div>
    <div class="meetings-section">
      <div id="current-meetings" class="section-title">
        {{ "Events" | translate }}
      </div>
      <ng-container *ngIf="cards.length">
        <div class="row">
          <div
            *ngFor="let card of cards"
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12"
          >
            <app-meeting-card
              [isMobile]="isMobile"
              [card]="card"
            ></app-meeting-card>
          </div>
        </div>
        <app-pagination
          *ngIf="currentMeta"
          [meta]="currentMeta"
          (goPage)="goCurrentPage($event)"
          (goNext)="nextCurrent()"
          (goPrev)="prevCurrent()"
        ></app-pagination>
      </ng-container>

      <ng-container *ngIf="!cards.length">
        <div class="empty-title">
        {{ "NoComingEvents" | translate }}
        </div>
      </ng-container>
    </div>

    <div class="meetings-section" *ngIf="previousCards.length">
      <div class="section-title">
        {{ "PreviousEvents" | translate }}
      </div>

      <div class="row">
        <div
          *ngFor="let card of previousCards"
          class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12"
        >
          <app-meeting-card
            [isMobile]="isMobile"
            [card]="card"
          ></app-meeting-card>
        </div>
      </div>
      <app-pagination
        *ngIf="previousMeta"
        [meta]="previousMeta"
        (goPage)="goPreviousPage($event)"
        (goNext)="nextPrevious()"
        (goPrev)="prevPrevious()"
      ></app-pagination>
    </div>
    <app-footer></app-footer>
  </div>
</div>
